import { useLocation } from 'react-router'

import { AdvisorLayerMode } from '../enums/advisorLayerMode'
import { getModeFromUrl } from '../utils/advisorLayerModeFromUrl'
import { readStoredMode } from '../utils/advisorLayerModeStorage'

// Single source of truth for the active advisor layer, shared by every React root.
// The URL wins (query param > path segment), localStorage is the persisted fallback,
// and Client is the default when nothing indicates otherwise. AdvisorLayerModeProvider
// resolves the same way (getModeFromUrl ?? its persisted state), so the toggle in the
// Menu root and consumers in the ViewContainer root can't resolve to different layers.
export const useResolvedAdvisorLayerMode = (): AdvisorLayerMode => {
  const { pathname, search } = useLocation()

  return getModeFromUrl(pathname, search) ?? readStoredMode() ?? AdvisorLayerMode.Client
}
